export default "__VITE_ASSET__BPxACbQM__"